import { useState } from 'react'

import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

import { WizardData } from '../types'

type Props = {
  excludedIds: number[]
  amplitudeEventNext: string
  manageEveryone: boolean
}

export const EmployeeSelectorStep = ({
  data,
  onDataChanged,
  amplitudeEventNext,
  excludedIds,
}: WizardStepRenderParams<WizardData> & Props) => {
  const [selected, setSelectedEmployees] = useState<EmployeeForSelectFragmentNoAccess[]>([])

  useOnNext(() => {
    track(amplitudeEventNext, {
      from: 'my_request',
    })
  })

  useUnsafeEffect(() => {
    onDataChanged({ ...data, employeeIds: selected.map((s) => s.id) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <Box gap="s24">
      <Text size="400" weight="medium" color="grey1000">
        {i18n.t('trainings.training_requests.create.employee_selector_step')}
      </Text>
      <EmployeeSelector
        excludeIds={excludedIds}
        alwaysOpen
        multiple
        value={selected}
        onSelect={setSelectedEmployees}
      />
    </Box>
  )
}
